import { Placement } from "react-joyride";
import { Link } from "react-router-dom";
import { JoyrideContentStyles } from "./JoyrideContentStyles";
import { START_OF_TOUR_PROPS } from "./START_OF_TOUR_PROPS";

export type JoyrideStep = {
  target: string;
  content?: React.ReactNode;
  translationKey?: string;
  disableScrolling?: boolean;
  placement?: "center" | "auto";
  placementBeacon?: Placement;
};

export const LOT_INFO_BAR_STEPS: JoyrideStep[] = [
  {
    target: `[data-component-name="Lot Info Bar"]`,
    disableScrolling: true,
    translationKey: "LOT_INFO_BAR_TOUR_STEP_1",
  },
];

// https://docs.react-joyride.com/step
export const getJoyrideGridPageSteps = (
  ckey: string,
  flightEnableLotInfoModule: boolean
): JoyrideStep[] => [
  {
    ...START_OF_TOUR_PROPS,
    content: (
      <JoyrideContentStyles>
        <div>Hey, welcome to Raven{`'`}s Dashboard page!</div>
        <div>
          Since there{`'`}s a lot going on here, we thought we{`'`}d offer to
          show you around.
        </div>
        <div>
          Click {`"`}Next{`"`} to continue...
        </div>
      </JoyrideContentStyles>
    ),
  },
  {
    target: `[data-component-name="Hublet View"]`,
    disableScrolling: true,
    content: (
      <JoyrideContentStyles>
        <div>
          Here is the <span className="bold">Hublet View</span>, a live snapshot
          of your process. In this view, you can see…
          <ol>
            <li>Current product you are running</li>
            <li>Tagged state</li>
            <li>Time in current state</li>
            <li>
              Preferred metric (see{" "}
              <Link to={`/${ckey}/settings`}>Settings page</Link> to change)
            </li>
            <li>Current rate and current count.</li>
          </ol>
        </div>
      </JoyrideContentStyles>
    ),
  },
  {
    target: `[data-component-name="PnL Chart"]`,
    placementBeacon: "top" as any,
    disableScrolling: true,
    content: (
      <JoyrideContentStyles>
        <div>
          Here, we have the shift’s{" "}
          <span className="bold">Performance and Loss table</span>, summarizing
          the performance this shift.
        </div>
      </JoyrideContentStyles>
    ),
  },
  {
    target: `[data-component-name="Trend Chart"]`,
    disableScrolling: true,
    content: (
      <JoyrideContentStyles>
        <div>
          This is the <span className="bold">Hourly Stacked Bar Chart</span>.
        </div>
        <div>Click on one of the bars for a summary of that hour.</div>
      </JoyrideContentStyles>
    ),
  },
  ...(flightEnableLotInfoModule ? LOT_INFO_BAR_STEPS : []),
  {
    target: `.TimeAxisStyles`,
    disableScrolling: true,
    content: (
      <JoyrideContentStyles>
        <div>
          And of course, here{`'`}s your <span className="bold">Timeline</span>!
        </div>
        <div>
          This real-time data visualization tells you the story of what happened
          throughout the shift or day.
        </div>
        <div>
          Click on a time segment to find out more about what happened, and
          when.
        </div>
      </JoyrideContentStyles>
    ),
  },
  {
    target: `#root`,
    placement: "center" as any,
    content: (
      <JoyrideContentStyles>
        <div>
          We{`'`}re hard at work on Raven Flight, to provide value where you
          need it most — so keep the feedback coming, and check back often for
          updates!
        </div>
      </JoyrideContentStyles>
    ),
  },
];
